import { preactConnectView } from 'common/module/preact/connect-view';
import { MyAccountMenuViewFactory } from 'desktop/module/my-account/menu/view.factory';

export const MyAccountMenuComponent = preactConnectView(MyAccountMenuViewFactory, (view, { base: element }) => {
  view.initialize({
    element: element as HTMLElement,
  });
  view.render();
});
